import { gql } from '@apollo/client';

export const ACTIVATE_PATIENT = gql`
  mutation ActivatePatient($email: String!) {
    activatePatient(email: $email) {
      succeeded
    }
  }
`;
